<div class="overlay-container" [hidden]="!isOpen" [attr.sh-id]="isOpen ? 'active-modal-dialog' : ''">
  <div class="overlay-backdrop overlay-dark-backdrop" [ngClass]="{'overlay-backdrop-showing': isOpen}" [ngStyle]="{ backgroundColor: overlayColor }"></div>
  <div class="overlay-wrapper">
    <div class="overlay-pane" [ngStyle]="{'width': width, 'minHeight': height}" outsideClickHandler (onOutsideClick)="onOutsideModalClick()">
      <ng-content></ng-content>
    </div>
  </div>
</div>
